import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import RequestApi from "../../api/RequestApi";
import EntityApi from "../../api/EntityApi";


export const updateDataThunk = createAsyncThunk(
    'slice/updateData',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await RequestApi.get('private/cart/total', {});
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

const initialState = {
    total: 0,
    status: 'idle',
    error: null
}

export const cartSlice = createSlice({
    name: 'cart',
    initialState: initialState,
    reducers: {
        setTotal: (state, action) => {
            state.total = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateDataThunk.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateDataThunk.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action.payload.status === EntityApi.STATUS_SUCCESS) {
                    state.total = action.payload.content.item.total;
                }
            })
            .addCase(updateDataThunk.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
})

export const cartSelector = (state) => state.cart;
export const { setTotal } = cartSlice.actions;
export default cartSlice.reducer;
